import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./fundingAccount.css";
import "../AssetOverview/assetOverview.css";

const rowsDemo = [
  { sym: "QQ", name: "Qoin" },
  { sym: "QG", name: "Qbitrium" },
  { sym: "1INCH", name: "1inch Network" },
  { sym: "ZZ", name: "ZyZag" },
  { sym: "XBST", name: "XBest" },
  { sym: "P", name: "PToken" },
  { sym: "ZUSD", name: "ZUSD" },
  { sym: "8A7", name: "8A7" },
  { sym: "AAVE", name: "Aave" },
  { sym: "ACH", name: "Alchemy Pay" },
  { sym: "ACN", name: "Acom" },
  { sym: "ACQ", name: "Acq4ive" },
  { sym: "ACS", name: "ACS" },
  { sym: "ACTSOL", name: "ActSol" },
];

export default function FundingAccountPage({ accountTitle = "Funding Account" }) {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const searchInputRef = useRef(null);
  const searchContainerRef = useRef(null);

  const toggleSearch = useCallback(() => {
    setSearchActive((v) => !v);
  }, []);

  useEffect(() => {
    if (!searchActive) return;
    const t = window.setTimeout(() => searchInputRef.current?.focus(), 320);
    return () => window.clearTimeout(t);
  }, [searchActive]);

  useEffect(() => {
    if (!searchActive) return;
    const onKey = (e) => {
      if (e.key === "Escape") setSearchActive(false);
    };
    const onClickOutside = (e) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(e.target)) {
        setSearchActive(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [searchActive]);
  const [hideSmall, setHideSmall] = useState(false);
  const [earnAssets, setEarnAssets] = useState(false);
  /** Mobile: bottom sheet with full row (same pattern as Asset Overview) */
  const [fundingRowModal, setFundingRowModal] = useState(null);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rowsDemo;
    return rowsDemo.filter((r) => r.sym.toLowerCase().includes(q) || r.name.toLowerCase().includes(q));
  }, [search]);

  return (
    <div className="dashboard_right funding-account wallet-page--ao-popup">
      <div className="funding-account__header">
        <div>
          <h1 className="funding-account__title">{accountTitle}</h1>
        </div>
        <div className="funding-account__header-actions">
          <button type="button" className="funding-account__pill funding-account__pill--primary" onClick={() => navigate("/asset_managemnet/deposit")}>
            Deposit
          </button>
          <button type="button" className="funding-account__pill" onClick={() => navigate("/asset_managemnet/deposit")}>
            Buy Crypto
          </button>
          <button type="button" className="funding-account__pill" onClick={() => navigate("/user_profile/wallet/funding")}>
            Transfer
          </button>
          <button type="button" className="funding-account__pill" onClick={() => navigate("/asset_managemnet/withdraw")}>
            Withdraw
          </button>
        </div>
      </div>

      <div className="funding-account__toprow">
        <div className="funding-account__totals">
          <div className="funding-account__totals-label">Total Assets</div>
          <div className="funding-account__totals-main">
            <span className="funding-account__totals-num">0 BTC</span>
            <span className="funding-account__totals-sub">≈ 0 USD</span>
          </div>
        </div>
        <button type="button" className="funding-account__details-btn">
          Account Details
        </button>
      </div>

      <div className="funding-account__filters rightsearch">
        <div
          ref={searchContainerRef}
          className={`searchBar custom-tabs ${searchActive ? "search_active" : ""}`}
          onClick={toggleSearch}
        >
          <i className="ri-search-2-line" aria-hidden="true" />
          <input
            ref={searchInputRef}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search"
            type="search"
            className="custom_search"
            aria-label="Search assets"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
        <label className="funding-account__check">
          <input type="checkbox" checked={hideSmall} onChange={(e) => setHideSmall(e.target.checked)} />
          Hide small balances
        </label>
        <label className="funding-account__check">
          <input type="checkbox" checked={earnAssets} onChange={(e) => setEarnAssets(e.target.checked)} />
          AGCX Earn assets
        </label>
      </div>

      <div className="funding-account__hintbar">
        <i className="ri-information-line" aria-hidden="true" />
        <span>
          To trade tokens, click Transfer to move the assets from your Funding Account to your Trading Account.
        </span>
      </div>

      <div className="funding-account__tablewrap">
        <table className="funding-account__table">
          <thead>
            <tr>
              <th>Coin</th>
              <th className="ta-r">Total Amount</th>
              <th className="ta-r">Available</th>
              <th className="ta-r">In Order</th>
              <th className="ta-r">BTC Value</th>
              <th className="ta-r">Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.sym}>
                <td data-label="Coin">
                  <div className="funding-account__coin flex-grow-1">
                    <span className="funding-account__coin-dot" aria-hidden="true" />
                    <div>
                      <div className="funding-account__coin-sym">{r.sym}</div>
                      <div className="funding-account__coin-name">{r.name}</div>
                    </div>
                  </div>
                </td>
                <td className="ta-r agce-ao-total-balance-cell" data-label="Total Amount">
                  <div className="d-flex align-items-center justify-content-end gap-2 agce-ao-mobile-total-with-more">
                    <div className="agce-ao-balance-stack funding-account__num-stack">
                      <div className="funding-account__num agce-ao-balance-stack__main">0</div>
                      <div className="funding-account__subnum agce-ao-balance-stack__fiat">≈ 0 USD</div>
                    </div>
                    <button
                      type="button"
                      className="agce-ao-more-btn d-inline-flex d-lg-none flex-shrink-0"
                      aria-label="View full row"
                      onClick={() => setFundingRowModal(r)}
                    >
                      <i className="ri-more-2-fill" aria-hidden="true" />
                    </button>
                  </div>
                </td>
                <td className="ta-r" data-label="Available">
                  <div className="funding-account__num">0</div>
                  <div className="funding-account__subnum">≈ 0 USD</div>
                </td>
                <td className="ta-r" data-label="In Order">
                  <div className="funding-account__num">0</div>
                  <div className="funding-account__subnum">≈ 0 USD</div>
                </td>
                <td className="ta-r" data-label="BTC Value">
                  <div className="funding-account__num">0</div>
                  <div className="funding-account__subnum">≈ 0 USD</div>
                </td>
                <td className="ta-r" data-label="Action">
                  <div className="funding-account__actions">
                    <Link to="/convert" className="funding-account__action">
                      Convert
                    </Link>
                    <Link to="/asset_managemnet/deposit" className="funding-account__action">
                      Deposit
                    </Link>
                    <Link to="/asset_managemnet/withdraw" className="funding-account__action">
                      Withdraw
                    </Link>
                    <button type="button" className="funding-account__action funding-account__action--btn">
                      Transfer
                    </button>
                    <Link to="/earning" className="funding-account__action">
                      Earn
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* These are UI-only toggles for now */}
      {hideSmall || earnAssets ? null : null}

      {fundingRowModal ? (
        <>
          <div className="agce-ao-detail-backdrop" role="presentation" onClick={() => setFundingRowModal(null)} />
          <div
            className="modal fade show d-flex agce-ao-sheet-modal"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="fundingRowModalTitle"
            style={{ zIndex: 1060 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable agce-ao-sheet-dialog">
              <div className="modal-content agce-ao-sheet border-0">
                <h2 id="fundingRowModalTitle" className="visually-hidden">
                  {fundingRowModal.sym} details
                </h2>
                <div className="agce-ao-sheet__header">
                  <div className="agce-ao-sheet__brand">
                    <span className="funding-account__coin-dot agce-ao-sheet__coin-dot" aria-hidden="true" />
                    <div>
                      <div className="agce-ao-sheet__sym">{fundingRowModal.sym}</div>
                      <div className="agce-ao-sheet__fullname">{fundingRowModal.name}</div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn-close agce-ao-sheet__close"
                    aria-label="Close"
                    onClick={() => setFundingRowModal(null)}
                  />
                </div>
                <div className="modal-body agce-ao-sheet__body">
                  <div className="agce-ao-sheet__hero">
                    <div className="agce-ao-sheet__hero-num">0</div>
                    <div className="agce-ao-sheet__hero-fiat">≈ 0 USD</div>
                  </div>
                  <div className="agce-ao-sheet__kvlist">
                    <div className="agce-ao-sheet__kv">
                      <span>Total Amount</span>
                      <span className="agce-ao-sheet__kv-val agce-ao-sheet__kv-val--accent">0</span>
                    </div>
                    <div className="agce-ao-sheet__kv">
                      <span>Available</span>
                      <span className="agce-ao-sheet__kv-val">0</span>
                    </div>
                    <div className="agce-ao-sheet__kv">
                      <span>In Order</span>
                      <span className="agce-ao-sheet__kv-val">0</span>
                    </div>
                    <div className="agce-ao-sheet__kv">
                      <span>BTC Value</span>
                      <span className="agce-ao-sheet__kv-val">0</span>
                    </div>
                  </div>
                  <div className="agce-ao-sheet__divider" />
                  <div className="agce-ao-sheet__table-actions">
                    <Link to="/convert" className="agce-ao-sheet__pill" onClick={() => setFundingRowModal(null)}>
                      Convert
                    </Link>
                    <Link
                      to="/asset_managemnet/deposit"
                      className="agce-ao-sheet__pill agce-ao-sheet__pill--primary"
                      onClick={() => setFundingRowModal(null)}
                    >
                      Deposit
                    </Link>
                    <Link to="/asset_managemnet/withdraw" className="agce-ao-sheet__pill" onClick={() => setFundingRowModal(null)}>
                      Withdraw
                    </Link>
                    <Link
                      to="/user_profile/wallet_transfer_History"
                      className="agce-ao-sheet__pill"
                      onClick={() => setFundingRowModal(null)}
                    >
                      Transfer
                    </Link>
                    <Link to="/earning" className="agce-ao-sheet__pill" onClick={() => setFundingRowModal(null)}>
                      Earn
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

